@if (loadingService.isLoading()) {
<div class="spinner">
  <img src="../../../assets/loading.gif" alt="Bouncing Message" />
</div>
}
